import { useMemo } from 'react';
import useClaimData from './useClaimData';
import useAppStateData from './useAppStateData';

export interface LoadingModalFlags {
    isVerifying: boolean;
    isVerified: boolean;
}

export const useLoadingModal = (): LoadingModalFlags => {
    const claimData = useClaimData();
    const appState = useAppStateData();

    return useMemo(
        () => ({
            isVerifying: appState.loadingModalFlag,
            isVerified: claimData.claimInfoLinkList.length !== 0,
        }),
        [appState.loadingModalFlag, claimData.claimInfoLinkList],
    );
};
